import { gql } from "@apollo/client";
import { TerminalTypesInfo } from "./getTerminalTypesCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";
import { Section } from "../../../../Components";
import { SectionsInfo } from "./getLfStructureCall";

export const PANEL_CREATE_SECTION = gql`
  mutation CreateSection($domain: String!, $sectionName: String!, $panelSectionType: Int!, $systemId: Int!, $section: [CreateLocation!]!, $terminalLinks: [CreateTerminalLink!]) {
    section {
      create(domain: $domain, sectionName: $sectionName, panelSectionType: $panelSectionType, systemId: $systemId, section: $section, terminalLinks: $terminalLinks) {
        code
        success
        message
        updatedValues
      }
    }
  }
`

export interface CreatePanelLocation {
  location_name: string;
  visual: string;
  terminals: {device_id: number, terminal_type?: number | null, config?: Omit<TerminalTypesInfo, "input">, port: number}[]
}

export interface CreateTerminalLink {
  device_id: number;
  port: number;
  next_device_id?: number;
  next_port?: number;
  parent_device_id?: number;
  parent_port?: number;
}

export interface CreatePanelLocationResponse {
  section: {
    create: Response;
  }
}

interface Response extends Def_MutationResponse {
  updatedValues?: number[]
}

export const PANEL_MAINTAIN_SECTION = gql`
  mutation Maintain($domain: String!, $sectionRenames: [RenameSection!]!, $locationRenames: [RenameLocation!]!, $terminalChanges: [UpdateTerminal!]!) {
    section {
      maintain(domain: $domain, sectionRenames: $sectionRenames, locationRenames: $locationRenames, terminalChanges: $terminalChanges) {
        code
        success
        message
        updatedValues {
          updatedSections {
            section_id
            name
          }
          updatedLocations {
            location_id
            name
          }
          updatedTerminals {
            terminal_id
            port
            fk_devices
            programmed
          }
        }
      }
    }
  }
`

export interface MaintainPanelSectionResponse {
  section: {
    maintain: Def_MutationResponse & { updatedValues: {
      updatedLocations: UpdatedLocations[],
      updatedSections: UpdatedSections[],
      updatedTerminals: UpdatedTerminal[]
    }};
  }
}

export interface MaintainPanelSectionParameters {
  domain: string,
  sectionRenames: RenameSection[],
  locationRenames: RenameLocation[],
  terminalChanges: UpdateTerminal[]
}

export interface UpdateTerminal {
  configProgrammed?: number,
  fk_devices?: number,
  port?: number,
  terminal_id: number
}

export interface RenameSection {
  new_name: string
  section_id: number
}

export interface RenameLocation {
  location_id: number
  new_name: string
}

export interface UpdatedTerminal {
  terminal_id: number,
  port?: number,
  fk_devices?: number,
  programmed?: number
}

interface UpdatedLocations {
  location_id: number,
  name: string
}

interface UpdatedSections {
  section_id: number,
  name: string
}